import news from './new.reducer'
import stories from './story.reducer'
import user from './users.reducer'

export default {
  user,
  news,
  stories,
}
